import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const BillingIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path d="M18 2H2C0.897 2 0 2.8852 0 3.97368V15.8158C0 16.9043 0.897 17.7895 2 17.7895H18C19.103 17.7895 20 16.9043 20 15.8158V3.97368C20 2.8852 19.103 2 18 2ZM2 15.8158V3.97368H18L18.001 15.8158H2Z" />
    <path d="M4.5 8.90779H7.5C7.776 8.90779 8 8.68674 8 8.41437V6.44069C8 6.16832 7.776 5.94727 7.5 5.94727H4.5C4.224 5.94727 4 6.16832 4 6.44069V8.41437C4 8.68674 4.224 8.90779 4.5 8.90779ZM4 11.8683H10V13.843H4V11.8683ZM11 11.8683H16V13.843H11V11.8683Z" />
  </SvgIcon>
);
